import React from 'react';
import { Hero } from './components/Hero';
import { TitleBlock } from './components/TitleBlock';
import { PainSection } from './components/PainSection';
import { ProblemReframe } from './components/ProblemReframe';
import { WhyOldSolutionsFail } from './components/WhyOldSolutionsFail';
import { SolutionReveal } from './components/SolutionReveal';
import { WhatsInside } from './components/WhatsInside';
import { Differentiation } from './components/Differentiation';
import { WhoItsFor } from './components/WhoItsFor';
import { PriceCTA } from './components/PriceCTA';
import { Footer } from './components/Footer';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { MidPageCTA } from './components/MidPageCTA';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  return <div className="min-h-screen bg-linen font-sans text-charcoal selection:bg-muted-blue/20 selection:text-charcoal" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <TitleBlock data-id="element-3" />
        <PainSection data-id="element-4" />
        <ProblemReframe data-id="element-5" />
        <WhyOldSolutionsFail data-id="element-6" />
        <SolutionReveal data-id="element-7" />
        <MidPageCTA data-id="element-8" />
        <WhatsInside data-id="element-9" />
        <Differentiation data-id="element-10" />
        <WhoItsFor data-id="element-11" />
        <Testimonials data-id="element-12" />
        <FAQ data-id="element-13" />
        <PriceCTA data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
      <FloatingCTA data-id="element-16" />
    </div>;
}